<template>
  <el-upload
      class="upload-demo"
      ref="fileUpload"
      action=""
      :show-file-list="false"
      :http-request="fnUploadRequest"
      :on-success="handleSuccess"
      :on-error="handleError"
      :before-upload="handleUpload"
    >
      <el-button type="danger" class="uploadBtn" @click="handleUpload">点击上传</el-button>
    </el-upload>
</template>
<script>
import { uploadOSS } from '@/utils/oss.js';
export default {
  props: {
    code: ''
  },
  name: "index",
  data() {
    return {};
  },
  methods: {
    handleExceed(file, fileList){
      this.$message.error('上传失败，限制上传数量10个文件以内！');
    },
    handleUpload(file, fileList){
      if (!this.code) {
        this.$message.error('请先填写验证码!');
      }
      return this.code
    },
    handleSuccess(res) {
      if (res) {
        this.$emit('fileData', res)
        this.$message.success("上传附件成功！");
      }
    },
    handleError(err){
      this.$message.error('上传附件失败！');
    },
    // 上传图片
    async fnUploadRequest(options) {
      try {
        let file = options.file; // 拿到 file
        let res = await uploadOSS(file)
        // 返回数据
        this.$emit("fileData", res);
        this.$message.success("上传附件成功！");
      } catch (e) {
        this.$message.error('上传附件失败！');
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/common/components/upload.vue